import { MODAL_NAME } from "../../../constants";
import { useAppSelector } from "../../../hooks/store-hooks";
import Activity from "./activity";
import Profile from "./profile";
import ReportUser from "./report-user";
import Trophy from "./trophy";

const UserProfile = () => {
  const { modalName } = useAppSelector((state: any) => state.modal ?? {});
  return (
    <div className="md:w-[767px] w-full rounded-lg flex flex-col gap-2  h-min">
      <Profile />
      <Trophy />
      <Activity />
      {modalName === MODAL_NAME.REPORT_USER ? <ReportUser /> : <></>}
    </div>
  );
};

export default UserProfile;
